import React, { useRef, useState, useEffect } from 'react'
import styles from './IssueType.module.css'
import TopTitleBar from './TopTitleBar';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import API from '../../../ApiConfig'
import { BASE_URL, USER_TOKEN } from '../../../Utils/constant'
import { Delay, _ToNormal, setDate } from '../../../Utils/helper';
import cogoToast from 'cogo-toast-react-17-fix';
import useRefreshToken from '../../../Hooks/usegenerateToken';
import Loader from '../../../components/Loader';
import { Icon } from 'react-icons-kit';
import { userAdd } from 'react-icons-kit/typicons/userAdd'
import { spreadsheet } from 'react-icons-kit/iconic/spreadsheet'
import { chevronRight } from 'react-icons-kit/oct/chevronRight'

import SlideUpWrapper from '../../../components/Transitions/SlideUpWrapper';
import ShimmerLoader from '../../../components/ShimmerLoader';
import PreviewPDF from '../../../components/pdfPreview/Previewpdf';
import Breadcrumb from '../../../components/Verifier/breadcrumb/BreadCrumb';
import IssuerNavigator from '../../../components/DashBoard/IssuerNavigator';


const IssueType = ({ handleStep, doc }) => {
  useRefreshToken(BASE_URL + USER_TOKEN)
  const [uploadtype, setUploadType] = useState('manual')
  const [loading, setLoading] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();
    const stepType = {
      'manual': 4,
      'bulk': 6
    }
    handleStep(stepType[uploadtype])
  }

  // useEffect(() => {
  //   setLoading(true);
  //   let doc = docsList.filter(e => e.id == templateId)
  //   console.log(doc);
  //   setSelectedOption(doc[0])
  //   setDoc(doc[0])
  //   setLoading(false);
  // }, [docsList, templateId])

  return (

    <div style={{width:"100%"}}>
      <Breadcrumb pos={2} title={'Issue Document'} category={'issuer'} />
      <SlideUpWrapper>
        <IssuerNavigator
          title={'Add Receipient Details'}
          handlestep={handleStep}
          step={2}
          actions={() => null}
        />

        <div className='issuer-container'>
          <div className="container justify-content-flex-start navItemContainer">
            <div style={{ width: '10rem', height: '13rem', overflow: 'hidden' }}>
              {doc && <PreviewPDF doc_id={doc.id} load={loading} setLoading={setLoading} type={'front_page'} />}
            </div>
            <div className="w-50">
              <h1 className="header-title">
                {doc.doc_name}
              </h1>
              <div className="issuer-label-wrapper">
                <span>Created on</span>
                <span className="issuer-label">{setDate(doc.updated_at)}</span>
              </div>
              <div className="issuer-label-wrapper">
                <span>Document Type</span>
                <span className="issuer-label">{doc.master_doc_name}</span>
              </div>
              <button className='btn btn-secondary' onClick={() => handleStep(1)} style={{ margin: 0, border: '1px solid var(--gray-300)' }}>Change Template</button>
            </div>
          </div>
          <hr></hr>
          <div className={styles.addRecipients}>
            <h2 className="header-title">
              Add recipients details
            </h2>
            <div className='justify-content-flex-start navItemContainer'>
              <div onClick={e => handleStep(4)} className='issuer-container container justify-content-flex-start navItemContainer' style={{ cursor: 'pointer', alignItems: 'center' }}>
                <div className={styles.icon} style={{ padding: '0.5rem', height: '2rem', width: '2rem', fontWeight: "700", fontSize: "15px", background: '#EBF1FF' }}>
                  <Icon icon={userAdd} style={{ color: '#253EA7' }} size={'1.5rem'} />
                </div>
                <div>
                  <div className={styles.title}>
                    Manually,one by one
                  </div>
                  <span className={styles.para} style={{ margin: 0 }}>
                    ideal for quick start
                  </span>
                </div>
                <Icon icon={chevronRight} />

              </div>

              <div onClick={e => handleStep(6)} className='issuer-container container justify-content-flex-start navItemContainer' style={{ cursor: 'pointer', alignItems: 'center' }}>
                <div className={styles.icon} style={{ padding: '0.5rem', height: '2rem', width: '2rem', fontWeight: "700", fontSize: "15px", background: '#EFFAF6' }}>
                  <Icon icon={spreadsheet} style={{ color: '#2D9F75' }} size={'1.5rem'} />
                </div>
                <div>
                  <div className={styles.title}>
                    Bulk Via CSV
                  </div>
                  <span className={styles.para} style={{ margin: 0 }}>
                    Upload via spredsheet
                  </span>
                </div>
                <Icon icon={chevronRight} />
              </div>
            </div>

          </div>
        </div>
        {/* <Loader isOpen={loading} /> */}

      </SlideUpWrapper >
    </div>
  )
}

export default IssueType
